var Enum = Enum || {};

Enum.MDX_ORDER_STATUS = {
    PREPARATION: 'PREPARATION',
    IN_PROGRESS: 'IN_PROGRESS',
    APPROVED: 'APPROVED',
    FINISHED: 'FINISHED',
    CANCELLED: 'CANCELLED',
    IN_VERIFICATION: 'IN_VERIFICATION'
};

Object.freeze(Enum.MDX_ORDER_STATUS);